import {create} from 'zustand'
import {devtools} from 'zustand/middleware'
import {ErrorWrap, SteddiError} from "../types/Error";

/**
 * This is the interface for the methods that will be available to the store.
 */
interface ErrorStateMethods {
  setError: (error: SteddiError) => void
}

/**
 * This is the interface for the state that will be available to the store.
 */
export interface ErrorState extends ErrorStateMethods {
  error: SteddiError | null
}

/**
 * This is the actual store.
 */
const useErrorStore = create<ErrorState>()(devtools(
  (set, get) => ({
    error: null,
    setError: (error) => set({error: error})
  })
))

export default useErrorStore